// 简体中文

import enLocale from 'element-ui/lib/locale/lang/zh-CN'
import appBackstage from './app_backstage/app_backstage_zh' // 后台文件（除 自定义应用模块）
import Navigation from './Navigation/Navigation_zh' // 首页
import login from './login/login_zh' // 登录注册
import chat from './chat/chat_zh' // im
import approval from './approval/approval_zh' // 前台审批
import attendance from './attendance/attendance_zh' // 考勤
import customBackstage from './custom_backstage/custom_backstage_zh' // 自定义后台
import customReception from './custom_reception/custom_reception_zh' // 自定义前台
import dataAnalysis from './data_analysis/data_analysis_zh' // 数据分析
import email from './email/email_zh' // 邮件
import knowledge from './knowledge/knowledge_zh' // 知识库
import library from './library/library_zh' // 文件库
import memo from './memo/memo_zh' // 备忘录
import projectTask from './project_task/project_task_zh' // 项目任务
import baseCommon from './base_common/base_common_zh' // 基础通用的（包括用户、公司、登录等信息）
import workbench from './workbench/workbench_zh' // 工作台
import globalSettings from './global_settings/global_settings_zh' // 工作台
import utils from './utils/utils_zh' // 工具类 如：constant、tool等
import salary from './salary/salary_zh' // 工具类 如：constant、tool等
import okr from './okr/okr_zh' // okr
import businessFlow from './business_flow/businessFlow_zh' // 业务流程
import personnelMatrix from './personnelMatrix/PersonnelMatrix_zh' // 人员矩阵
export default {
  ...enLocale,
  ...appBackstage,
  ...Navigation,
  ...login,
  ...chat,
  ...approval,
  ...attendance,
  ...customBackstage,
  ...customReception,
  ...dataAnalysis,
  ...email,
  ...knowledge,
  ...library,
  ...memo,
  ...projectTask,
  ...baseCommon,
  ...workbench,
  ...globalSettings,
  ...utils,
  ...salary,
  ...okr,
  ...businessFlow,
  ...personnelMatrix
}
